import { render, staticRenderFns } from "./CurriculaCursoOferta.vue?vue&type=template&id=18c2fbba&"
import script from "./CurriculaCursoOferta.vue?vue&type=script&lang=js&"
export * from "./CurriculaCursoOferta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports